import { render } from "./NotificationDetail.vue?vue&type=template&id=be4b8c1a"
import script from "./NotificationDetail.vue?vue&type=script&lang=js"
export * from "./NotificationDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__